import { Middleware } from 'redux';

import { selectCatalogFilter } from '@lib/tools/catalogFilter/selectors';
import { applyCatalogFilter } from '@lib/tools/catalogFilter/slices/catalogFilter';
import MixpanelTracker from '@lib/tools/dat/mixpanel';

export const analyticsMiddleware: Middleware = store => next => action => {
  const result = next(action);

  if (action.type === applyCatalogFilter.type) {
    const appliedCatalogFilters = selectCatalogFilter(store.getState());
    MixpanelTracker.events.productCatalogFilter(appliedCatalogFilters);
  }

  return result;
};
